export const pk = "pk_live_51LZmUnBVOISGCHPEL4LnCov4aN3Y9HKtLLFg5zpDAlGfNivSzCGN94RgJz2HmWKbKTfhwhfGW0RbHELNc9wRQTjP00GTJhUxrf";
export const paymentSuccessReturnPrefixURL = "https://pagohoy.com/pagoconfirmado/";
// export const paymentSuccessReturnPrefixURL = http://localhost:3000/